import type {
	MacResponse, MappedMac, DeviceStatusResponse
} from '@/components/internal/account/equipment/types'

const mapMacResponse = (response: MacResponse): MappedMac => {
	const {
		accountMacId, accountId, deviceName, macAddress, lastModified, createdTime, equipmentInfo, serialNumber
	} = response

	const mappedMac: MappedMac = {
		macId: accountMacId,
		accountId,
		deviceName,
		macAddress,
		serialNumber,
		lastModified: formatDate(new Date(lastModified)),
		created: formatDate(new Date(createdTime)),
		equipmentId: equipmentInfo?.equipmentId?.toString() || '',
		equipmentBrand: equipmentInfo?.equipmentBrand || ''
	}

	return mappedMac
}

const addStatusToMac = (mac: MappedMac, deviceStatus: DeviceStatusResponse): MappedMac => {
	// Convert Cambium status 'online' to match the other status 'active'
	const status = deviceStatus?.status === 'online' ? 'active' : deviceStatus.status
	return {
		...mac,
		status: status || 'unknown',
		uptime: formatTimerForDisplay(deviceStatus?.uptime) || 'unknown',
		lastSeen: formatDate(new Date(deviceStatus?.lastSeen)) || 'unknown',
		ipAddress: deviceStatus?.ipAddress || 'unknown'
	}
}

export { mapMacResponse, addStatusToMac }
